import React from "react";
import ReactDOM from "react-dom";
import ArtistsWidget from "../widgetComponents/artistsWidget/artists-widget";

ReactDOM.render(<ArtistsWidget />, document.querySelector("#ArtistsWidget"));
